import React, { useState, useEffect } from "react";
import {
  AddSlabIcon,
  DeleteIcon
} from "../../../utility/constants/assetsManager";
import {
  colorLightGrey,
  colorWhite,
  secondaryColor
} from "../../../utility/constants/colorManager";

import "./index.css";
import SlabContainerComp from "./SlabContainerComp";
import "../../../scrollStyles.css";
import { useSnackbar } from "notistack";

import { Controller, useFieldArray, useForm } from "react-hook-form";

import { Radio, Select, TimePicker } from "antd";
import { FaEdit } from "react-icons/fa";
import "./index.css";
import { CustomButton } from "../main_comps/custom_button";
import dayjs from "dayjs";
import {
  SETTLEMENT_CYCLES,
  SETTLEMENT_HOURLY,
  SETTLEMENT_INSTANT,
  SETTLEMENT_MANUAL,
  SETTLEMENT_TPLUSONE
} from "../../../utility/constants/valueConstants";
import ComissionContainer from "./ComissionContainer";
import { forwardRef } from "react";
const HourSelector = ({ onClickSave, settlementData }) => {
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      type: "hourly",
      hourlySettlements:
        settlementData && settlementData.hourlySettlement
          ? [{ value: settlementData.hourlySettlement }]
          : [{ value: 1 }]
    }
  });

  const { fields } = useFieldArray({
    control,
    name: "hourlySettlements" // Use a unique name for the field array
  });

  useEffect(() => {
    if (settlementData) {
      setValue("hourlySettlements.value", settlementData.hourlySettlement, {
        shouldDirty: true
      });
    }
  }, []);

  const onSubmit = (data) => {
    const { value } = data.hourlySettlements[0]; // Extract the value from the first item in hourlySettlements array
    onClickSave({ hourlySettlement: value });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {fields.map((item, index) => (
        <div key={item.id}>
          <Controller
            control={control}
            name={`hourlySettlements.${index}.value`}
            defaultValue={1}
            render={({ field }) => (
              <Select
                {...field}
                style={{ width: 120 }}
                onChange={field.onChange}
                size="large"
                setValue={setValue}
                value={field.value} // Add value prop to maintain the selected value
              >
                <Select.Option value={1}>1 hr</Select.Option>
                <Select.Option value={2}>2 hrs</Select.Option>
                <Select.Option value={3}>3 hrs</Select.Option>
              </Select>
            )}
          />
        </div>
      ))}
      <div className="w-full justify-end items-end flex mt-4">
        <CustomButton
          style={{ color: "secondaryColor", fontSize: 13 }} // Make sure to provide a valid color value
          title="Save"
          type="submit"
        />
      </div>
    </form>
  );
};

// ADDED ON THE CYCLE"S VALIDATION PROPERLY

const CycleHourMinuteForms = ({ onClickSave, cycles, settlementData }) => {
  const [isEditMode, setIsEditMode] = useState(false); // State to track edit mode
  const [savedSettlement, setSavedSettlement] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      cycleTimings:
        settlementData && settlementData.cycles
          ? settlementData.cycles.map((cycle) => ({
              fromKey: new Date(cycle.from),
              tillKey: new Date(cycle.to),
              cycleKey: cycle.triggerTime,
              fromPrevDay: cycle.fromGroup.fromPrevDay,
              fromCurrentDay: cycle.fromGroup.fromCurrentDay,
              toPrevDay: cycle.toGroup.toPrevDay,
              toCurrentDay: cycle.toGroup.toCurrentDay
            }))
          : cycles && cycles.length > 0
          ? cycles.map((cycle) => ({
              fromKey: new Date(cycle.from),
              tillKey: new Date(cycle.to),
              cycleKey: cycle.triggerTime,
              fromPrevDay: cycle.fromGroup.fromPrevDay,
              fromCurrentDay: cycle.fromGroup.fromCurrentDay,
              toPrevDay: cycle.toGroup.toPrevDay,
              toCurrentDay: cycle.toGroup.toCurrentDay
            }))
          : [
              {
                fromKey: "",
                tillKey: "",
                cycleKey: "",
                fromPrevDay: false,
                fromCurrentDay: true,
                toPrevDay: false,
                toCurrentDay: true
              }
            ]
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "cycleTimings"
  });

  const addCycle = () => {
    const cycleTimings = watch("cycleTimings");
    // console.log(cycleTimings, "TIMINGS");

    if (!cycleTimings || cycleTimings.length === 0) {
      append({
        fromKey: "",
        tillKey: "",
        cycleKey: "",
        fromPrevDay: false,
        fromCurrentDay: true,
        toPrevDay: false,
        toCurrentDay: true
      });
      return;
    }

    const lastCycle = cycleTimings[cycleTimings.length - 1];
    const isEmpty = Object.values(lastCycle).some((value) => value === "");

    const invalidTimings = cycleTimings.some((cycle) => {
      const from = new Date(cycle.fromKey);
      const to = new Date(cycle.tillKey);
      const fromPrev = cycle.fromPrevDay;
      const toPrev = cycle.toPrevDay;
      if (fromPrev === true && toPrev === true) {
        return from >= to;
      }

      if (fromPrev) {
        return false;
      }
    });

    if (invalidTimings) {
      enqueueSnackbar("To Time cannot be less than From time", {
        variant: "error"
      });
      return;
    }

    if (!isEmpty) {
      if (cycleTimings.length < 5) {
        append({
          fromKey: "",
          tillKey: "",
          cycleKey: "",
          fromPrevDay: false,
          fromCurrentDay: true,
          toPrevDay: false,
          toCurrentDay: true
        });
      }
    } else {
      enqueueSnackbar(
        "Please fill all fields in the current cycle before adding a new one.",
        {
          variant: "error"
        }
      );
    }
  };
  useEffect(() => {
    if (settlementData && settlementData.cycles) {
      const mappedData = settlementData.cycles.map((cycle, index) => {
        const triggerTime = cycle.triggerTime.split(":");
        const cycleKeyDate = dayjs()
          .set("hour", parseInt(triggerTime[0]))
          .set("minute", parseInt(triggerTime[1]));

        return {
          fromKey: dayjs(cycle.from),
          tillKey: dayjs(cycle.to),
          cycleKey: cycleKeyDate,
          fromPrevDay: cycle.fromGroup.fromPrevDay || false,
          fromCurrentDay: cycle.fromGroup.fromCurrentDay || true,

          toPrevDay: cycle.toGroup.toPrevDay || false,
          toCurrentDay: cycle.toGroup.toCurrentDay || true
        };
      });

      setValue("cycleTimings", mappedData, {
        shouldDirty: true
      });
    }
  }, [settlementData, setValue]);
  const toggleEditMode = () => {
    setIsEditMode((prevMode) => !prevMode); // Toggle the edit mode
  };

  useEffect(() => {
    if (savedSettlement.length > 0) {
      setIsEditMode(true); // Toggle the edit mode
    } else {
      setIsEditMode(false);
    }
  }, [savedSettlement.length > 0]);

  const onSubmit = (data) => {
    const { cycleTimings } = data;

    // Custom validation for each cycle timing
    const invalidTimings = cycleTimings.some((cycle) => {
      const from = new Date(cycle.fromKey);
      const to = new Date(cycle.tillKey);
      const fromPrev = cycle.fromPrevDay;

      const toPrev = cycle.toPrevDay;
      if (fromPrev === true && toPrev === true) {
        return from >= to;
      }

      if (fromPrev) {
        return false;
      }

      return from >= to;
    });

    if (invalidTimings) {
      enqueueSnackbar("To Time cannot be less than From time", {
        variant: "error"
      });
      return;
    }

    const invalidSelection = cycleTimings.some((cycle) => {
      return cycle.fromCurrentDay && cycle.toPrevDay;
    });

    if (invalidSelection) {
      enqueueSnackbar(
        "To cannot be set to Previous Day when From is set to Today",
        {
          variant: "error"
        }
      );
      return;
    }

    const formattedData = data.cycleTimings.map((cycle, index) => {
      console.log(index, "cycle_1");
      const fromMilliseconds = new Date(cycle.fromKey).setMilliseconds(0);
      const toMilliseconds = new Date(cycle.tillKey).setMilliseconds(999);

      const cycleKeyDate = new Date(cycle.cycleKey);
      const hours = cycleKeyDate.getHours().toString().padStart(2, "0");
      const minutes = cycleKeyDate.getMinutes().toString().padStart(2, "0");
      const triggerTime = `${hours}:${minutes}`;

      const fromGroup = {
        fromPrevDay: cycle.fromPrevDay || false,
        fromCurrentDay: cycle.fromCurrentDay || false
      };

      const toGroup = {
        toPrevDay: cycle.toPrevDay || false,
        toCurrentDay: cycle.toCurrentDay || false
      };

      const fromDay = fromGroup.fromPrevDay ? false : true;

      const toDay = toGroup.toPrevDay ? false : true;

      const cycleName = `cycle_${index + 1}`;

      // console.log(`cycleTimings.${index}.cycleKey`, "TIMINGGSSSS");

      return {
        name: cycleName.toUpperCase(),
        from: new Date(fromMilliseconds),
        to: new Date(toMilliseconds),
        triggerTime: triggerTime,
        fromDay,
        toDay,
        fromGroup,
        toGroup
      };
    });
    setSavedSettlement(formattedData);

    onClickSave(formattedData);

    toggleEditMode();
  };

  useEffect(() => {
    console.log(savedSettlement, "seaved settlement");
  }, [savedSettlement]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!isEditMode ? (
          <>
            <div className="flex flex-col justify-start items-start w-full my-2">
              <ul>
                {fields.map((item, index) => {
                  return (
                    <>
                      <li key={item.id} className="flex flex-row ">
                        <div className="w-full flex-col space-y-1">
                          <label
                            htmlFor={`cycleTimings.${index}.fromKey`}
                            className="text-sm block"
                          >
                            From
                          </label>
                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.fromKey`}
                            rules={{
                              required: true
                            }}
                            setValue={setValue}
                            render={({ field: { onChange, value } }) => (
                              <>
                                <TimePicker
                                  format="HH:mm:ss"
                                  value={
                                    value ? dayjs(value, "HH:mm:ss") : null
                                  }
                                  onChange={(date) => onChange(date)}
                                  suffixIcon={null}
                                  size="large"
                                  className="text-lg font-bold w-[80%]"
                                  allowClear={false}
                                  required
                                  showNow={true}
                                />
                              </>
                            )}
                          />
                        </div>

                        <div className="w-full flex-col space-y-1">
                          <label
                            htmlFor={`cycleTimings.${index}.tillKey`}
                            className="text-sm block"
                          >
                            To
                          </label>
                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.tillKey`}
                            rules={{
                              required: true
                            }}
                            setValue={setValue}
                            render={({ field: { onChange, value } }) => (
                              <TimePicker
                                format="HH:mm:ss"
                                value={value ? dayjs(value, "HH:mm:ss") : null}
                                onChange={(date) => onChange(date)}
                                suffixIcon={null}
                                size="large"
                                className="text-lg font-bold w-[80%]"
                                allowClear={false}
                                required
                              />
                            )}
                          />
                        </div>

                        <div className="border-l-2 w-full pl-2 space-y-1">
                          <label
                            htmlFor={`cycleTimings.${index}.cycleKey`}
                            className="text-sm block"
                          >
                            Cycle {index + 1}
                          </label>
                          <Controller
                            control={control}
                            rules={{
                              required: true
                            }}
                            setValue={setValue}
                            name={`cycleTimings.${index}.cycleKey`}
                            render={({ field: { onChange, value } }) => (
                              <TimePicker
                                format="HH:mm"
                                suffixIcon={null}
                                size="large"
                                className="text-lg font-bold w-[80%]"
                                allowClear={false}
                                onChange={(date) => onChange(date)}
                                value={value ? dayjs(value, "HH:mm:ss") : null}
                                required
                              />
                            )}
                          />
                        </div>

                        <div className="flex items-center justify-between cursor-pointer pt-4">
                          <DeleteIcon onClick={() => remove(index)} />
                        </div>
                      </li>

                      <div className="flex flex-row text-sm py-4 text-black justify-start">
                        <div className="w-[50%]">
                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.fromPrevDay`}
                            render={({ field }) => (
                              <Radio
                                id={`fromDay-${index}`}
                                name={`cycleTimings.${index}.fromPrevDay`}
                                checked={field.value === true}
                                onChange={(e) => {
                                  field.onChange(true);
                                  setValue(
                                    `cycleTimings.${index}.fromCurrentDay`,
                                    false
                                  );
                                }}
                              >
                                P
                              </Radio>
                            )}
                          />

                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.fromCurrentDay`}
                            setValue={setValue}
                            render={({ field }) => (
                              <Radio
                                id={`toDay-${index}`}
                                name={`cycleTimings.${index}.fromCurrentDay`}
                                checked={field.value === true}
                                onChange={(e) => {
                                  field.onChange(true);
                                  setValue(
                                    `cycleTimings.${index}.fromPrevDay`,
                                    false
                                  );
                                }}
                              >
                                T
                              </Radio>
                            )}
                          />
                        </div>
                        {/* TO prev and next */}
                        <div className="w-[100%]">
                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.toPrevDay`}
                            render={({ field }) => (
                              <Radio
                                id={`fromDay-${index}`}
                                name={`cycleTimings.${index}.toPrevDay`}
                                checked={field.value === true}
                                onChange={(e) => {
                                  field.onChange(true);
                                  setValue(
                                    `cycleTimings.${index}.toCurrentDay`,
                                    false
                                  );
                                }}
                              >
                                P
                              </Radio>
                            )}
                          />

                          <Controller
                            control={control}
                            name={`cycleTimings.${index}.toCurrentDay`}
                            setValue={setValue}
                            render={({ field }) => (
                              <Radio
                                id={`toDay-${index}`}
                                name={`cycleTimings.${index}.toCurrentDay`}
                                checked={field.value === true}
                                onChange={(e) => {
                                  field.onChange(true);
                                  setValue(
                                    `cycleTimings.${index}.toPrevDay`,
                                    false
                                  );
                                }}
                              >
                                T
                              </Radio>
                            )}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
              </ul>
            </div>
            <div className="items-start w-full justify-start py-2 flex">
              {fields.length < 5 ? (
                <p style={{ color: "gray", fontSize: 13 }}>
                  You can add up to 5 cycles
                </p>
              ) : (
                <p style={{ color: "gray", fontSize: 13 }}>
                  You have reached the limit, can’t add more cycles
                </p>
              )}
            </div>

            <button
              type="button"
              className="items-start w-full justify-start  flex"
              onClick={addCycle}
            >
              <AddSlabIcon type="submit" style={{ marginRight: 15 }} />
              <p style={{ color: secondaryColor, fontSize: 13 }}>
                Add More Cycle
              </p>
            </button>
          </>
        ) : (
          <div>
            {savedSettlement.length > 0 && (
              <p className="font-normal">Settlement Timings</p>
            )}

            {savedSettlement && (
              <div>
                {savedSettlement.map((cycle, index) => (
                  <div key={index}>
                    <p>
                      <span className="font-semibold border-r-2 pr-2">
                        Cycle {index + 1}
                      </span>
                      <span className="font-bold border-r-2 pr-2 px-2">
                        {cycle.triggerTime}
                      </span>
                      <span className="text-[#7181a1] px-2">
                        Time Range:{" "}
                        {cycle.from
                          ? `${new Date(cycle.from).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit"
                            })} 
                ${
                  cycle.fromGroup && cycle.fromGroup.fromPrevDay
                    ? "(P)"
                    : cycle.fromGroup && cycle.fromGroup.fromCurrentDay
                    ? "(T)"
                    : ""
                }`
                          : "N/A"}{" "}
                        -{" "}
                        {cycle.to
                          ? `${new Date(cycle.to).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit"
                            })} 
                ${
                  cycle.toGroup && cycle.toGroup.toPrevDay
                    ? "(P)"
                    : cycle.toGroup && cycle.toGroup.toCurrentDay
                    ? "(T)"
                    : ""
                }`
                          : "N/A"}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="w-full justify-end items-end flex mt-4">
          {!isEditMode ? (
            <CustomButton
              style={{ color: secondaryColor, fontSize: 13 }}
              title="Save"
              type="submit"
            />
          ) : (
            <div className="bg-white text-white fill-white">
              <CustomButton
                style={{ fontSize: 13 }}
                title="Edit"
                type="button"
                onClick={toggleEditMode}
                icon={<FaEdit style={{ fontSize: 12 }} />}
              />
            </div>
          )}
        </div>
      </form>
    </>
  );
};

const Tplus = ({ onClickSave, settlementData }) => {
  // // console.log(settlementData, "jsdjfdsjkllkj");
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      time:
        settlementData && settlementData.tPlusOneTime
          ? [{ time: settlementData.tPlusOneTime }]
          : [{ time: "" }]
    }
  });

  const { fields } = useFieldArray({
    control,
    name: "time"
  });

  useEffect(() => {
    if (settlementData) {
      setValue("time", dayjs(settlementData.tPlusOneTime).format("HH:mm"), {
        shouldDirty: true
      });
    }
  }, []);

  const onSubmit = (data) => {
    // // // // console.log(data);
    const tPlusOneTime = data.time[0]?.time.format("HH:mm");
    onClickSave({ tPlusOneTime });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {fields.map((time, index) => (
        <div key={index} className="w-[50%] flex-col space-y-1">
          <p htmlFor={`time[${index}].time`} className="text-sm block">
            Set Time
          </p>
          <Controller
            control={control}
            name={`time[${index}].time`}
            setValue={setValue}
            render={({ field: { onChange, value } }) => (
              <TimePicker
                format="HH:mm"
                value={value ? dayjs(value, "HH:mm") : null}
                onChange={(date) => onChange(date)}
                suffixIcon={null}
                size="large"
                className="text-lg font-bold w-[40%] "
                allowClear={false}
                required
              />
            )}
          />
        </div>
      ))}
      <div className="items-end flex w-full justify-end p-2 cursor-pointer">
        <CustomButton
          style={{ color: secondaryColor, fontSize: 13 }}
          title="Save"
          type="submit"
        />
      </div>
    </form>
  );
};

const Instant = ({ onClickSave, settlementData }) => {
  // console.log(settlementData, "INSTANT_DATA");
  // // // // console.log(onClickSave, "ON_SAVINGS");
  const { handleSubmit } = useForm();

  const [settlementCommission, setSettlementCommission] = useState([]);
  const [flatSettlementData, setFlatSettlementData] = useState([]);
  const [comissionType, setComissionType] = useState("");

  const onSubmit = () => {
    onClickSave({ settlementCommission, flatSettlementData, comissionType }); // Pass the data to onClickNext or any other function
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <div>
      {/* Your other JSX */}
      {/* {method === SETTLEMENT_INSTANT && ( */}
      <div style={{ margin: 10, display: "flex", flexDirection: "column" }}>
        <div style={{ color: "black" }}>
          <div className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="py-4">
                <ComissionContainer
                  // callBackDetails={callBackDetails}
                  styles={{
                    width: "343px",
                    background: "white",
                    minHeight: "71px",
                    borderRadius: "6px",
                    border: "1px solid #CBCACA"
                  }}
                  innerStyles={{
                    marginLeft: "-12px",
                    marginTop: "-8px"
                  }}
                  onClickNext={(data, flatData, type) => {
                    // // // // console.log(data, flatData, type, "ONCLICKDATA");
                    if (data.length > 0) {
                      setSettlementCommission(data);
                    }

                    if (flatData) {
                      setFlatSettlementData(flatData);
                    }
                    if (type) {
                      setComissionType(capitalizeFirstLetter(type));
                    }
                  }}
                  onClickSave={(e) => {
                    // console.log(e, "EVENT_CLICKED");
                  }}
                  isSlabRequired={true}
                  settlementData={settlementData}
                />
                <div className="items-end flex w-full justify-end p-2 cursor-pointer">
                  <CustomButton
                    style={{ color: secondaryColor, fontSize: 13 }}
                    title="Save"
                    type="submit"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* )} */}
    </div>
  );
};

export const Divider = ({ style }) => {
  return (
    <div
      style={{
        backgroundColor: "#D9D9D9",
        height: 80,
        width: 1,
        ...style
      }}
    ></div>
  );
};
const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "max-content"
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
          display: "flex"
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

export const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};

export const checkAnyOneObjHasAllValue = (obj) => {
  if (Object.keys(obj)?.length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).some((val) => {
      return obj[val] !== "";
    });
    return val;
  }
};

function SettlementContainer({
  onClickNext,
  styles,
  innerStyles,
  rate,
  type,
  disabled = false,
  onClickDelete,
  settlementData
}) {
  // // // console.log(settlementData, "CHILD_SETTLEMENT_DATA");
  const [method, setMethod] = useState("instant");
  // // // console.log(method, "1233456678");

  const [totalCommission, setTotalCommission] = useState([]);

  const [flatComission, setFlatComission] = useState({});
  const [comissionObj, setComissionObj] = useState({});
  const [isValuesAdded, setIsValuesAdded] = useState(false);
  const [currentObject, setCurrentObject] = useState({});
  const [empty, setEmpty] = useState("flat");
  //   const [isCycle, setIsCycle] = useState('')
  const { enqueueSnackbar } = useSnackbar();
  const [instantMethod, setInstantMethod] = useState("flat");

  useEffect(() => {
    if (totalCommission.length > 0)
      onClickNext([...totalCommission], {}, method);
  }, [totalCommission]);

  useEffect(() => {
    if (checkObjHasAllValue(currentObject))
      onClickNext([...totalCommission, comissionObj], {}, method);
  }, [currentObject, method]);

  useEffect(() => {
    onClickNext([], flatComission, method);
  }, [flatComission, method]);

  useEffect(() => {
    if (instantMethod === "flat") {
      setTotalCommission([]);
    } else {
      setFlatComission({});
      setEmpty("slab");
    }
  }, [instantMethod]);

  useEffect(() => {
    if (type && type?.toLowerCase() === "flat") {
      setInstantMethod("flat");
      setFlatComission(rate[0]);
    } else if (type && type?.toLowerCase() === "slab") {
      setInstantMethod("slab");
      setTotalCommission(rate);
    }
  }, [type, rate]);

  useEffect(() => {
    // console.log(first)
    if (settlementData && settlementData?.method) {
      setMethod(settlementData.method);
    }
  }, []);

  return (
    <>
      <div
        style={{
          width: "100%",
          backgroundColor: colorLightGrey,
          boxSizing: "border-box",
          padding: 10,
          ...styles
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "15px 0px",
            ...innerStyles
          }}
        >
          <form
            style={{
              flex: 0.55,
              display: "flex"
            }}
          >
            <RadioButton
              disabled={disabled}
              id={SETTLEMENT_INSTANT}
              name="method"
              title="Instant"
              value={SETTLEMENT_INSTANT}
              onChange={(val) => {
                setMethod(val.target.value);
              }}
              defaultChecked={method === SETTLEMENT_INSTANT}
              style={{
                margin: "0px 10px"
              }}
            />

            <RadioButton
              disabled={disabled}
              id={SETTLEMENT_CYCLES}
              name="method"
              title="Cycles"
              value={SETTLEMENT_CYCLES} // Corrected value attribute
              onChange={(val) => {
                setMethod(val.target.value);
              }}
              defaultChecked={method === SETTLEMENT_CYCLES}
              style={{
                margin: "0px 10px"
              }}
            />

            <>
              <RadioButton
                disabled={disabled}
                id={SETTLEMENT_HOURLY}
                name="method"
                title="Hourly"
                value={SETTLEMENT_HOURLY}
                onChange={(val) => {
                  setMethod(val.target.value);
                }}
                defaultChecked={method === SETTLEMENT_HOURLY}
                style={{
                  margin: "0px 10px"
                }}
              />
            </>

            <RadioButton
              disabled={disabled}
              id={SETTLEMENT_TPLUSONE}
              name="method"
              title="T + 1 Days"
              value={SETTLEMENT_TPLUSONE}
              onChange={(val) => {
                setMethod(val.target.value);
              }}
              defaultChecked={method === SETTLEMENT_TPLUSONE}
              style={{
                margin: "0px 10px"
              }}
            />

            <RadioButton
              disabled={disabled}
              id="manual"
              name="method"
              title="Manual"
              value="manual"
              onChange={(val) => {
                setMethod(val.target.value);
              }}
              defaultChecked={method === SETTLEMENT_MANUAL}
              style={{
                margin: "0px 10px"
              }}
            />
            {/* <p>
              Select topping <strong>{method}</strong>
              Select topping <strong>{instantMethod}</strong>
            </p> */}
          </form>
        </div>
        {instantMethod === "slab" && (
          <div
            style={{
              width: "100%",
              backgroundColor: colorWhite,
              maxHeight: 300,
              overflow: "auto"
            }}
          >
            {totalCommission &&
              totalCommission?.map((data, i) => (
                <SlabContainerComp
                  from={data.from}
                  to={data.to}
                  value={data.value}
                  type={data.type}
                  id={i}
                  onClickDelete={(id) => {
                    const filteredData = totalCommission.filter(
                      (val, i) => i !== id
                    );
                    onClickDelete([...filteredData]);
                    setTotalCommission([...filteredData]);
                  }}
                  method={method}
                  empty={empty}
                />
              ))}
          </div>
        )}

        {instantMethod === "slab" && (
          <div
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              margin: "10px 0px",
              width: "auto"
            }}
            onClick={() => {
              if (checkObjHasAllValue(comissionObj)) {
                setTotalCommission([...totalCommission, comissionObj]);
                setComissionObj({});
                //  onObjAdded();
                setCurrentObject({});
                setIsValuesAdded(true);
              } else {
                enqueueSnackbar("Please enter all the fields", {
                  variant: "error"
                });
              }
            }}
          >
            <AddSlabIcon
              style={{
                marginRight: 15
              }}
            />
            <p
              style={{
                color: secondaryColor,
                fontSize: 13
              }}
            >
              Add More Slab
            </p>
          </div>
        )}
      </div>

      {/* INSTANT */}
      <div>
        {method === SETTLEMENT_INSTANT && (
          <div
            style={{
              margin: 10,
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div style={{ color: "black" }}>
              {/* <HourSelector onClickSave={onClickNext} type={"hourly"} /> */}
              <Instant
                onClickSave={onClickNext}
                type={SETTLEMENT_INSTANT}
                settlementData={settlementData}
              />
            </div>
          </div>
        )}
      </div>
      {/* HOURLY */}
      <div>
        {method === SETTLEMENT_HOURLY && (
          <div
            style={{
              margin: 10,
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div style={{ color: "black" }}>
              <HourSelector
                onClickSave={onClickNext}
                type={SETTLEMENT_HOURLY}
                settlementData={settlementData}
              />
            </div>
          </div>
        )}
      </div>
      {/* Cycle */}
      <div >
        {method === SETTLEMENT_CYCLES && (
          <div style={{ margin: 10 }}>
            <div style={{ color: "black" }}>
              <CycleHourMinuteForms
                onClickSave={onClickNext}
                type={SETTLEMENT_CYCLES}
                settlementData={settlementData}
              />
            </div>
          </div>
        )}
      </div>
      {/* tplus */}
      <div>
        {method === SETTLEMENT_TPLUSONE && (
          <div style={{ margin: 10 }}>
            <div>
              <Tplus
                onClickSave={onClickNext}
                type={"t+1"}
                settlementData={settlementData}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SettlementContainer;
